import React from 'react';
import { dfs } from '../../utils';
import { Tooltip, Dropdown } from '@platform/base';
import { Menu } from 'antd';
const { Item, Divider } = Menu;
import './index.less';

const SORT_ASC = "SORT_ASC";
const SORT_DESC = "SORT_DESC";
const FLAG_SORT_ASC = 1;
const FLAG_SORT_DESC = -1;

const FILTER = "FILTER";
const LOCATION = "LOCATION";
const SORT_BY_GROUP = "SORT_BY_GROUP";
const FREEZE_FIELD = "FREEZE_FIELD";
const UNFREEZE_FIELD = "UNFREEZE_FIELD";
const HIDDEN_FIELD = "HIDDEN_FIELD";

export default function useFieldSetting(Table) {
    return class useFieldSetting extends React.Component {
        constructor(props) {
            super(props);
            this.state = { showDropColKey: new Set() };
        }

        render() {
            let { columns = [], fieldSettingConfig, fieldid, id } = this.props;
            let { showDropColKey } = this.state;
            let { enable } = fieldSettingConfig;
            if (enable) {
                {
                    columns = dfs(columns, (col, index) => {
                        if (!col.fieldSettingable) {
                            return col;
                        }
                        return {
                            ...col,
                            title: (
                                <>
                                    {col.title}
                                    <Tooltip
                                        placement="top"
                                        overlay=''
                                        delayShow={300}
                                    >
                                        <Dropdown
                                            fieldid={`${fieldid || id}_setting-menu`}
                                            trigger={['click']}
                                            overlay={this.renderMenu(col, index, columns)}
                                            placement={'bottomLeft'}
                                            animation="slide-up"
                                            overlayClassName='setting-wrapper'
                                            onVisibleChange={value => {
                                                if (value) {
                                                    showDropColKey.add(col.key);
                                                } else {
                                                    showDropColKey.delete(col.key);
                                                }
                                                this.setState({ showDropColKey });
                                            }}
                                        >
                                            <i
                                                className='header-icon header-icon-drop icon-hover-show'
                                                style={{ display: showDropColKey.has(col.key) ? 'flex' : 'none' }}
                                            >
                                                <i className="iconfont icon-a-xialajiantou1x drop-icon" />
                                            </i>
                                        </Dropdown>
                                    </Tooltip>
                                </>
                            ),
                        };
                    });
                }
            }

            return <Table
                {...this.props}
                columns={columns}
            />;
        }

        renderMenu = (col, index, columns) => {
            let {
                sortConfig = {},
                filterConfig = {},
                locationConfig = {},
                groupSortConfig = {},
                locale,
                contextMenuConfig,
                layoutMode,
                fieldid,
                id,
            } = this.props;
            let { enable: sortEnable } = sortConfig,
                { enable: FilterEnable } = filterConfig,
                { enable: locationEnable } = locationConfig,
                { enable: groupSortEnable = true } = groupSortConfig,
                { cancelCustomRightMenu } = contextMenuConfig;
            let childSortEnable = layoutMode === "flat" ? !col.isChildCol : true; //拉平表中子表禁止排序，其他表格没有这个限制
            let renderSort = sortEnable && !col.children && col.sortable,
                renderFilter = FilterEnable && !col.children && col.filterable,
                renderGroupSort = groupSortEnable && renderSort,
                renderFreeze = !cancelCustomRightMenu && !col.islock && !col.depth,
                renderUnfreeze = !cancelCustomRightMenu && col.islock && !columns[++index]?.islock && !col.depth,
                renderHidden = !cancelCustomRightMenu && !col.depth && !col.required;

            let hasColSettingIcon = renderFreeze || renderUnfreeze || renderHidden;
            return <div fieldid={`${fieldid || id}_setting-menu`}>
                <Menu
                    mode="vertical"
                    onClick={e => this.handleMenuClick(e, col)}
                    fieldid={`setting-menu-${col.attrcode}`}
                >
                    {renderSort && <Item fieldid={`${fieldid || id}_setting-menu-sort-asc`} key={SORT_ASC}>
                        <i className="iconfont icon-a-liebiao-shengxu1x" />
                        <span>{locale['table_asc']/**升序 */}</span>
                    </Item>}
                    {renderSort && <Item fieldid={`${fieldid || id}_setting-menu-sort-desc`} key={SORT_DESC}>
                        <i className="iconfont icon-a-liebiao-jiangxu1x" />
                        <span>{locale['table_desc'] /**降序 */}</span>
                    </Item>}
                    {renderSort && <Divider className="first-divider" />}
                    {renderFilter && <Item fieldid={`${fieldid || id}_setting-menu-filter`} key={FILTER}>
                        <i className="iconfont icon-a-liebiao-shaixuan1x" />
                        <span>{locale['table_filter'] /**过滤 */}</span>
                    </Item>}
                    {renderGroupSort && <Item fieldid={`${fieldid || id}_setting-menu-group-sort`} key={SORT_BY_GROUP}>
                        <i className="iconfont icon-a-liebiao-zuhepaixu1x" />
                        <span>{locale['table_sort_by_group'] /**组合排序 */}</span>
                    </Item>}
                    {locationEnable && <Item fieldid={`${fieldid || id}_setting-menu-location`} key={LOCATION}>
                        <i className="iconfont icon-a-liebiao-dingwei1x" />
                        <span>{locale['table0043'] /**定位 */}</span>
                    </Item>}
                    {hasColSettingIcon && <Divider className="second-divider" />}
                    {renderFreeze && <Item fieldid={`${fieldid || id}_setting-menu-freeze`} key={FREEZE_FIELD}>
                        <i className="iconfont icon-a-liebiao-suoding1x" />
                        <span>{locale['table_freeze']/**冻结至此字段 */}</span>
                    </Item>
                    }
                    {renderUnfreeze && <Item fieldid={`${fieldid || id}_setting-menu-unfreeze`} key={UNFREEZE_FIELD}>
                        <i className="iconfont icon-a-liebiao-jiesuo1x" />
                        <span>{locale['table_unfreeze']/**解锁冻结字段*/}</span>
                    </Item>
                    }
                    {renderHidden && <Item fieldid={`${fieldid || id}_setting-menu-hide`} key={HIDDEN_FIELD}>
                        <i className="iconfont icon-a-liebiao-yincangziduan1x" />
                        <span>{locale['table_hidden']/**隐藏字段*/}</span>
                    </Item>}
                </Menu>
            </div>;
        };
        
        handleMenuClick = (e, col) => {
            let {
                    sortConfig = {},
                    filterConfig = {},
                    locationConfig = {},
                    groupSortConfig = {},
                } = this.props,
                { onSortClick } = sortConfig,
                { onGroupSortClick } = groupSortConfig,
                { onFilterClick } = filterConfig,
                { onLocationClick } = locationConfig;
            switch (e.key) {
                case SORT_ASC:
                    onSortClick(col, FLAG_SORT_ASC);
                    break;
                case SORT_DESC:
                    onSortClick(col, FLAG_SORT_DESC);
                    break;
                case FILTER:
                    onFilterClick(col);
                    break;
                case LOCATION:
                    onLocationClick(col);
                    break;
                case SORT_BY_GROUP:
                    onGroupSortClick(col);
                    break;
                case FREEZE_FIELD:
                    this.handleFreeze(col);
                    break;
                case UNFREEZE_FIELD:
                    this.onUnlockCol(col);
                    break;
                case HIDDEN_FIELD:
                    this.handleHiddenCol(col);
                    break;
                default:
            }
            this.setState({ showDropColKey: new Set() });
        }

        handleFreeze = col => {
            let { colSettingMethod = {} } = this.props;
            let { onLockCol, renderContent } = colSettingMethod;
            renderContent(
                null,
                () => {
                    onLockCol(col, 'lockSuccess');
                },
            );
        }

        onUnlockCol = col => {
            let { colSettingMethod = {} } = this.props;
            let { onUnlockCol, renderContent } = colSettingMethod;
            renderContent(
                null,
                () => {
                    onUnlockCol(col, 'unlockSuccess');
                },
            );
        }

        handleHiddenCol = col => {
            let { colSettingMethod = {} } = this.props;
            let { onHiddenCol, renderContent } = colSettingMethod;
            renderContent(
                null,
                () => {
                    onHiddenCol(col, 'hideSuccess');
                },
            );
        }
    };

}

useFieldSetting.displayName = 'useFieldSetting';
useFieldSetting.dependence = [];
useFieldSetting.hooks = function () {
    return {};
};
useFieldSetting.propsGenerator = function (props) {
    return { ...props };
};

